import { apiGet, apiPost } from './client';
import type { SigningKey } from '@/types';

interface ApiSigningKey {
  kid: string;
  algorithm: string;
  createdAt: string;
  expiresAt: string | null;
  isActive: boolean;
  isCurrent: boolean;
}

function transformKey(key: ApiSigningKey): SigningKey {
  return {
    kid: key.kid,
    algorithm: key.algorithm,
    created_at: key.createdAt,
    expires_at: key.expiresAt,
    is_active: key.isActive,
    is_current: key.isCurrent,
  };
}

export const keysApi = {
  list: async (): Promise<SigningKey[]> => {
    const data = await apiGet<ApiSigningKey[]>('/api/keys');
    return data.map(transformKey);
  },

  rotate: async (): Promise<{ kid: string; message: string }> =>
    apiPost<{ kid: string; message: string }>('/api/keys/rotate'),

  retire: async (kid: string): Promise<{ kid: string; retired: boolean }> =>
    apiPost<{ kid: string; retired: boolean }>(`/api/keys/${encodeURIComponent(kid)}/retire`),
};
